import { useState } from "react";
import { tickerItems, siteNav, quickLinks } from "@/mocks/site";

export default function HeaderShell() {
  const [open, setOpen] = useState(false);
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="relative z-40">
      {/* 压顶快讯滚动条 */}
      <div className="bg-primary-700 text-background-50">
        <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-1.5 md:px-6">
          <span className="eyebrow inline-flex shrink-0 items-center gap-1.5 bg-primary-500 px-2.5 py-1 text-[11px] font-bold tracking-widest text-background-50">
            <span className="live-dot h-1.5 w-1.5 rounded-full bg-background-50" />
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track gap-10">
              {loop.map((it, i) => (
                <span key={i} className="flex shrink-0 items-center gap-2 text-xs text-background-100">
                  <i className="ri-triangle-fill text-[9px] text-accent-400" />
                  <em className="not-italic font-bold text-accent-300">{it.tag}</em>
                  <span className="truncate max-w-[560px]">{it.text}</span>
                </span>
              ))}
            </div>
          </div>
          <a
            href="#timeline"
            className="eyebrow hidden shrink-0 items-center gap-1 text-[11px] font-semibold text-background-200 transition-colors hover:text-background-50 sm:flex"
          >
            全部快讯 <i className="ri-arrow-right-s-line" />
          </a>
        </div>
      </div>

      {/* 杂志品牌头 */}
      <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1400px] flex-wrap items-center justify-between gap-3 px-4 py-3 md:px-6 md:py-4">
          <a href="#top" className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center bg-primary-500 font-display text-2xl font-black text-background-50">
              曝
            </span>
            <span className="leading-none">
              <span className="block font-display text-[26px] font-black tracking-tight text-foreground-950">
                曝瓜<span className="text-primary-600">网</span>
              </span>
              <span className="eyebrow mt-1 block text-[10px] text-foreground-500">用石锤说话 · 证据归档站</span>
            </span>
          </a>

          <nav className="order-3 hidden w-full items-center justify-between border-t border-dashed border-background-200 pt-2 lg:order-none lg:flex lg:w-auto lg:border-0 lg:pt-0">
            <div className="flex items-center gap-5 overflow-x-auto">
              {[
                { label: "实锤时间线", href: "#timeline" },
                { label: "聊天记录", href: "#chat" },
                { label: "截图档案", href: "#shots" },
                { label: "录音曝光", href: "#audio" },
                { label: "热评", href: "#comments" },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="ml-6 flex items-center gap-2">
              <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-foreground-500">
                <i className="ri-search-line text-sm" />
                <input
                  type="text"
                  placeholder="搜索事件 / 关键词"
                  className="w-36 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
              <a
                href="#"
                className="whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-upload-cloud-2-line mr-1" />
                投稿实锤
              </a>
            </div>
          </nav>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-700 md:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-lg`} />
          </button>
        </div>

        {/* 频道条 */}
        <div className="border-t border-background-200 bg-background-100/60">
          <div className="mx-auto flex max-w-[1400px] items-center gap-1 overflow-x-auto px-4 md:px-6">
            <span className="eyebrow mr-2 hidden shrink-0 items-center text-[11px] font-bold text-foreground-500 md:flex">
              <i className="ri-settings-3-line mr-1" /> 频道
            </span>
            {siteNav.map((c) => (
              <a
                key={c.key}
                href={c.key === "latest" ? "#timeline" : "#top"}
                className="flex shrink-0 items-center gap-1.5 whitespace-nowrap px-3 py-2 text-[13px] font-medium text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className={`${c.icon} text-sm text-primary-500`} />
                {c.label}
              </a>
            ))}
          </div>
        </div>
      </header>

      {/* 移动端面板 */}
      {open && (
        <div className="border-b border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {[
              { label: "实锤时间线", href: "#timeline" },
              { label: "聊天记录", href: "#chat" },
              { label: "截图档案", href: "#shots" },
              { label: "录音曝光", href: "#audio" },
              { label: "热评", href: "#comments" },
            ].map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </div>
          <div className="mt-3 flex flex-col gap-2">
            <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2 text-foreground-500">
              <i className="ri-search-line text-sm" />
              <input
                type="text"
                placeholder="搜索事件 / 关键词"
                className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </div>
            <a
              href="#"
              className="whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-center text-sm font-bold text-background-50"
            >
              <i className="ri-upload-cloud-2-line mr-1" />
              投稿实锤
            </a>
          </div>
          <div className="mt-4 grid grid-cols-4 gap-2 border-t border-dashed border-background-200 pt-3">
            {quickLinks.map((q) => (
              <a
                key={q.label}
                href="#"
                className="flex flex-col items-center gap-1 rounded-md bg-background-100 py-2 text-[11px] text-foreground-600"
              >
                <i className={`${q.icon} text-base text-primary-500`} />
                {q.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}